import { useView } from '../app/use-view.ts'
import { KeyHint } from '../components/key-hint.tsx'
import { useT } from '../i18n/index.ts'
import styles from './skip-hint.module.css'

/**
 * Bottom right while something can be skipped (a lift ride): the skip key, then what it
 * skips. Touch shows the Skip button instead.
 */
export function SkipHint() {
  const t = useT()
  const skip = useView((view) => view.hud.skip)
  const device = useView((view) => view.input.device)
  const label = useView((view) => view.input.labels.skip)
  if (!skip || device === 'touch') return null

  return (
    <p class={styles.hint} role="status">
      {device === 'keyboardMouse' && <KeyHint label={label.keyboard} variant="key" />}
      {device === 'gamepad' && <KeyHint label={label.gamepad} variant="button" />}
      <span>{t(skip)}</span>
    </p>
  )
}
